import Interaction from "../../../models/interactions/Interaction";
import { IParallelSequence } from "../../../models/interactions/ParallelSequence";
import NodeToggle from "../components/NodeToggle";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function ParallelSequenceNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as IParallelSequence;
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <NodeToggle
        label="Finish All"
        value={interaction.finishAll}
        onChange={(finishAll) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            finishAll,
          } as IParallelSequence)
        }
      />
      <NodeToggle
        label="Abort Others on Finish"
        value={interaction.abortOthersOnFinish}
        onChange={(abortOthersOnFinish) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            abortOthersOnFinish,
          } as IParallelSequence)
        }
      />
    </div>
  );
}
